export const SELECTED_TAB_SET = 'at/reports/dashboard/createReportPopup/SELECTED_TAB_SET'


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/actionTypes.js